/** @tsx tsx */
import React, {useState} from "react";
import styled from "@emotion/styled";
import {Box, ButtonStyled, DatePickerStyled, TextFieldStyled} from "@nike/nike-design-system-components";
import ChangeLogTable from "./ChangeLogTable";

const StyledAppContainer = styled.div`
    margin: 3em auto;
    width: 90%;
`;

export class SearchFilters {
    service: string = "";
    eventDateBefore: string = "";
    eventDateAfter: string = "";
    author: string = "";
}
const ChangelogDashboard = () => {
    const [service, setService] = useState("");
    const [eventDateBefore, setEventDateBefore] = useState("");
    const [eventDateAfter, setEventDateAfter] = useState("");
    const [author, setAuthor] = useState("");
    const [searchFilters, setSearchFilters] = useState(new SearchFilters())

    return (
        <StyledAppContainer>
            <Box borderRadius="xl" className="eds-grid eds-grid--cols-4">
                <TextFieldStyled id={"search-service"} name={"search-service"}
                                 crossOrigin={undefined}
                                 label={"Service"}
                                 value={service}
                                 onChange={(event) => setService(event.target.value)}
                />
                <DatePickerStyled id={"event-date-before"} label={"Event Date Before"} name={"event-date-before"}
                                  crossOrigin={undefined}
                                  value={eventDateBefore}
                                  onChange={(event) => setEventDateBefore(event.target.value)}/>
                <DatePickerStyled id={"event-date-after"} label={"Event Date After"} name={"event-date-after"}
                                  crossOrigin={undefined}
                                  value={eventDateAfter}
                                  onChange={(event) => setEventDateAfter(event.target.value)}/>
                <TextFieldStyled id={"search-author"} name={"search-author"} crossOrigin={undefined}
                                 label={"Author Email"}
                                 value={author}
                                 onChange={(event) => setAuthor(event.target.value)}/>
            </Box>
            <Box className="eds-grid eds-grid--cols-8">
                <ButtonStyled
                    style={{marginBottom: 20}}
                    id={"search-changelogs"}
                    appearance="primary"
                    className="responsive-btn"
                    onClick={() => {
                        // set search filters
                        setSearchFilters({
                            service,
                            eventDateBefore,
                            eventDateAfter,
                            author
                        })
                    }}>
                    Search
                </ButtonStyled>
                <ButtonStyled
                    style={{marginBottom: 20}}
                    id={"search-changelogs"}
                    appearance="secondary"
                    className="responsive-btn"
                    onClick={() => {
                        // set search filters
                        setService("");
                        setAuthor("");
                        setEventDateAfter("");
                        setEventDateBefore("");
                        setSearchFilters({author: "", eventDateAfter: "", eventDateBefore: "", service: ""})
                    }}>
                    Clear
                </ButtonStyled>
            </Box>
            <ChangeLogTable filters={searchFilters} />
        </StyledAppContainer>
    );
};

export default ChangelogDashboard;
